import { ContentUserContext } from 'context/corporatiu/ContentUserProvider';
import { useContext } from 'react';

export const useButlletins = () => {
    const {
        getSubscripcionsButlletins,
        addSubscripcioButlleti,
        removeSubscripcioButlleti,
        itemsSubscripcionsButlletins,
        isLoading
    } = useContext(ContentUserContext);
    return {
        getSubscripcionsButlletins,
        addSubscripcioButlleti,
        removeSubscripcioButlleti,
        itemsSubscripcionsButlletins,
        isLoading
    };
};
